import api from '@pray/shared/utils/api';

export interface WorkflowStats {
  total: number;
  active: number;
  stopped: number;
  draft: number;
}

interface GetWorkflowStatsParams {
  artistId: string;
}

/**
 * Fetch workflow automation statistics (aggregate counts)
 *
 * Returns accurate total, active, stopped, and draft counts
 * directly from the database without pagination.
 *
 * @param params.artistId - Artist ID (required)
 * @returns Promise with workflow stats
 */
interface WorkflowStatsApiResponse {
  data: Array<{ resource: WorkflowStats }>;
}

export async function getWorkflowStats({ artistId }: GetWorkflowStatsParams): Promise<WorkflowStats> {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/workflows/stats`;
  const response = await api.executeGetRequest<WorkflowStatsApiResponse>(url);

  // sendSuccessResponse wraps data as: { data: [{ resource: { ...stats } }] }
  const resource = response?.data?.data?.[0]?.resource;
  return resource || (response.data as unknown as WorkflowStats);
}
